import { StateEnum } from "@vitable/asclepius-api-client-ts"
import { DateTime } from "luxon"

export const IS_PROD = import.meta.env.VITE_APP_ENV === "prod"
export const IS_DEV = import.meta.env.VITE_APP_ENV === "dev"
export const IS_UAT = import.meta.env.VITE_APP_ENV === "uat"

export const SERVER_URL = import.meta.env.VITE_APP_SERVER_URL
export const ADOBE_CLIENT_ID = import.meta.env.VITE_APP_ADOBE_CLIENT_ID
export const GOOGLE_KEY = import.meta.env.VITE_APP_GOOGLE_KEY
export const SENDBIRD_APP_ID = import.meta.env.VITE_APP_SENDBIRD_APP_ID

export const AYVA_API_URL = import.meta.env.VITE_APP_AYVA_SERVER_URL
export const AYVA_WEB_URL = import.meta.env.VITE_APP_AYVA_WEB_URL
export const AYVA_CLIENT_ID = import.meta.env.VITE_APP_AYVA_CLIENT_ID

export const GAIA_URL = import.meta.env.VITE_APP_GAIA_URL
export const HYGIEIA_URL = import.meta.env.VITE_APP_HYGIEIA_URL
export const CARE_NAVIGATION_TOOL_URL = `${HYGIEIA_URL}/coverage`
export const MARKETING_SITE_URL = "https://www.vitablehealth.com"
export const VITABLE_PHONE_NUMBER = "4844160769"

export const CLINIC_CHECKIN_URL =
  import.meta.env.VITE_APP_CLINIC_CHECKIN_URL === undefined
    ? "http://localhost:8081/clinic-checkin"
    : import.meta.env.VITE_APP_CLINIC_CHECKIN_URL

export const VITABLE_PROFILE_PIC_DEFAULT = "https://vitable-assets.s3.amazonaws.com/member-mobile-app/vitable_logo.png"

// The States that Vitable covers
export const SUPPORTED_US_STATES = {
  Dc: StateEnum.Dc,
  De: StateEnum.De,
  Il: StateEnum.Il,
  Md: StateEnum.Md,
  Nj: StateEnum.Nj,
  Pa: StateEnum.Pa
}

// Availability Creation
export const MAXIMUM_SLOT_DURATION_HOURS = 8
export const MINIMUM_PROVIDER_SPLIT_AVAILABILITY_LENGTH_HOURS = 1

// Labs
export const QUEST_HG_INTEGRATION_ROLLOUT_DATETIME = DateTime.fromObject(
  { year: 2023, month: 7, day: 6, hour: 17, minute: 30 },
  { zone: "America/New_York" }
)

export const LABCORP_ACCOUNT_NUMBER = "37053780"
export const QUANUM_URL = "https://physician.quanum.questdiagnostics.com/home"
export const LABCORP_EMPLOYER_SOLUTIONS_PORTAL_URL = "https://www.labcorpsolutions.com/ots/passwordChange.do"
export const QUEST_FULFILLMENT_INSTRUCTIONS_URL =
  "https://docs.google.com/document/d/1q6lly05PONlloRn-hBCBNGsrapLfYif0bb1W1xZjQn4/edit?usp=sharing"
export const QUEST_RESULT_UPLOADING_INSTRUCTIONS_URL =
  "https://docs.google.com/document/d/1Jo91Ilgyl544vdJsx9JWbkvxgkB0IpOboFua6xneSQU/edit?usp=sharing"
export const LABCORP_DRUG_AND_ALCOHOL_FULFILLMENT_INSTRUCTIONS_URL =
  "https://docs.google.com/document/d/1C76AUkJJGtVW-0AylmlI-8WRdQynXhONbKL7ZmkUy-0/edit"
export const HEALTH_GORILLA_URL = import.meta.env.VITE_APP_HEALTH_GORILLA_URL

// Freshpaint
export const FRESHPAINT_TOKEN = import.meta.env.VITE_APP_FRESHPAINT_TOKEN

export const CLINICAL_ADMINS_WITH_CHAT_ACCESS = [
  "mia@vitablehealth.com",
  "katie.m@vitablehealth.com",
  "naam.corpuz@peaksupport.io",
  "healeymeredith@gmail.com"
]

export const PRODUCTION_CARE_COORDINATION_TEMPLATE_ID = "c98191b3-7d17-46de-9492-f01dd9ae2325"

// Feature Flags

export const SHOW_POST_VISIT_CHECK_IN_FEATURE = false
